import { clickableClassName, draggableClassName } from 'pxc-editor-material-svg-rendering/components/shared/InteractiveSvg';

export default ({ clickable, draggable }) => {
  const classString = [];

  if (clickable) {
    classString.push(clickableClassName);
  }
  if (draggable) {
    classString.push(draggableClassName);
  }

  return classString.join(' ');
};
